import { useEffect, useState } from "react"
import { useAuth } from "../contexts/AuthProvider"

const ProfilePage = () => {
  const { user, loading } = useAuth()
  const [DashboardComponent, setDashboardComponent] = useState(null)

  console.log("ProfilePage rendered with user:", user)

  useEffect(() => {
    if (loading) return
    if (!user?.authenticated) {
      window.location.href = "/login"
      return
    }

    // Dynamically import based on user type
    if (user?.accountType === "candidate") {
      import("../components/CandidateDashboard").then((module) => {
        setDashboardComponent(() => module.default)
      })
    } else {
      import("../components/CompanyDashboard").then((module) => {
        setDashboardComponent(() => module.default)
      })
    }
  }, [user])

  if (!DashboardComponent) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", backgroundColor: "#ffffff" }}>
        Loading...
      </div>
    )
  }

  return <DashboardComponent />
}

export default ProfilePage
